import { render } from "./CustomToaster.vue?vue&type=template&id=3caea7cf"
import script from "./CustomToaster.vue?vue&type=script&lang=js"
export * from "./CustomToaster.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__